import React from 'react';
import Slider from 'react-slick';
import Countdown from './Countdown';
import Cdbg from '../images/countdown_page.jpg';

const productImages = [
    //'../images/countdown_page.jpg',
    //'http://jftheskinspecialist.com/assets/img/slider/slider2-v5.jpg',
    //'http://jftheskinspecialist.com/assets/img/slider/slider1-v2.jpg',
    {
        name: 'Semarang x Beauty',
        description: '2024-12-31T23:59:59',
    },
    {
        name: 'Surabaya x Beauty',
        description: '2024-11-31T23:59:59',
    },
];


const CountdownView = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        //dotsClass: "button__bar",
        customPaging: i => (
            <button className="slick-dot button__bar"></button>
        ),
    };


    return (
        <div className="max-w-12xl mx-auto bg-[#feec87]">
            <div className="relative">
                {/*<Slider {...settings}>
                    {productImages.map((set, index) => (
                        <div key={index}>
                            <div className="relative">
                                <img src={Cdbg} className="w-full" style={{ height: 'auto' }} alt="" />
                                <div className="absolute inset-0 bg-opacity-5 flex items-center justify-center text-white p-4 text-center">
                                    <p style={{ paddingLeft: 480, paddingBottom: 480, color: '#fd7a12', fontFamily: 'MuseoSansRounded700', fontSize: 40 }}>{set.name}</p>
                                    <p className='sm:hidden' style={{ paddingLeft: 655, paddingTop: 0, color: '#fd7a12', fontFamily: 'MuseoSansRounded700', fontSize: 40 }}>{set.name}</p>
                                </div>
                                <div className="absolute inset-0 bg-opacity-5 flex items-center justify-center text-white p-4 text-center">
                                    <p style={{ paddingLeft: 480, paddingTop: 60 }}><Countdown targetDate={set.description} /></p>
                                    <p className='sm:hidden' style={{ paddingLeft: 655, paddingTop: 0 }}><Countdown targetDate={set.description} /></p>
                                </div>
                            </div>
                        </div>
                    ))}

                </Slider>*/}
                <div class="hidden lg:block" style={{ height: '50px' }}>&nbsp;</div>
            </div>
        </div>
    );
};

export default CountdownView;
